import { RoomContext, useTracks } from "@livekit/components-react";
import { log } from "@livekit/components-core";
import { Track, LocalVideoTrack, LocalParticipant } from "livekit-client";
import React, { useContext, useEffect } from "react";
import shareScreenIcon from '../../assets/share-screen.png';

export function ScreenShare() {
  const [screenShare, setscreenShare] = React.useState(false);
  const [prePublish, setPrePublish] = React.useState(new Set<string>());
  const room = useContext(RoomContext);

  const tracks = useTracks(
    [{ source: Track.Source.ScreenShare, withPlaceholder: false }],
    {}
  ).filter((track) => !(track.participant instanceof LocalParticipant));;

  const enableScreenShare = async () => {
    if (!room) return;
    let track = room.localParticipant.getTrack(Track.Source.ScreenShare);
    try {
      if (!screenShare && !prePublish.has(Track.Source.ScreenShare)) {
        const selectedScreen = await (window as any).electronAPI.screenShare();
        await screenShareResHandler(null, selectedScreen);
        setscreenShare(true);
      } else if (screenShare) {
        if (track?.track)
          await room.localParticipant.unpublishTrack(track.track);
        prePublish.delete(Track.Source.ScreenShare);
        setPrePublish(prePublish);
        setscreenShare(false);
      }
    } catch (e) {
      log.warn(e);
      setscreenShare(false);
    }
  };

  useEffect(() => {
    if (!!tracks.length) {
      if (screenShare)
        enableScreenShare();
    }
  }, [tracks.length]);

  const screenShareResHandler = async (event: any, res: { sourceId: string; }) => {
    const constraints: any = {
      audio: false,
      video: {
        mandatory: {
          chromeMediaSource: "desktop",
          chromeMediaSourceId: res.sourceId,
          frameRate: 15
        },
      },
    };
    let screenStream = await navigator.mediaDevices.getUserMedia(constraints);
    const localVideoTrack = new LocalVideoTrack(screenStream.getVideoTracks()[0]);
    localVideoTrack.source = Track.Source.ScreenShare;
    let screenTrack = await room?.localParticipant.publishTrack(localVideoTrack, {
      videoEncoding: {
        maxBitrate: 2_500_000,
        maxFramerate: 15
      },
      screenShareEncoding: {
        maxBitrate: 2_500_000,
        maxFramerate: 15
      }
    });
    setPrePublish(prePublish.add(Track.Source.ScreenShare));
  };

  return (
    <button className="screenShareBtn" onClick={enableScreenShare}>
      <div className="screenShareBtn_flex">
        <img className="shareScreenIcon" src={shareScreenIcon} alt="" />
        <span>{screenShare ? 'Stop Screen Share' : 'Screen Share'}</span>
      </div>
    </button>
  );
}